import { ReactNode } from "react";

interface ListRendererProps<T> {
  items: T[] | undefined;
  isLoading: boolean;
  loadingComponent: ReactNode;
  isError?: boolean;
  errorComponent?: ReactNode;
  emptyComponent: ReactNode;
  children: ReactNode;
}

export const ListRenderer = <T,>({
  items,
  isLoading,
  isError,
  loadingComponent,
  errorComponent,
  emptyComponent,
  children,
}: ListRendererProps<T>) => {
  if (isLoading) {
    return loadingComponent;
  }
  if (isError) {
    return errorComponent;
  }
  if (items?.length === 0) {
    return emptyComponent;
  }
  return children;
};
